import { useAppNavigation } from "@/shared/hooks/useAppNavigation";
import { EmptyState } from "@/shared/components/ui/EmptyState";
import { ErrorState } from "@/shared/components/ui/ErrorState";
import { RowSkeleton } from "@/shared/components/ui/RowSkeleton";
import { Page, PageContent } from "@/shared/components/ui/Page";
import { PageHeader } from "@/shared/components/ui/PageHeader";
import { useParams } from "react-router-dom";
import { ServiceEdit, type ServiceFormValues } from "../components/ServiceEdit";
import { useService, useUpdateService } from "../hooks/serviceQueries";

export function ServiceEditPage() {
  const { serviceId } = useParams<{ serviceId: string }>();
  const { goToServiceDetails } = useAppNavigation();

  const { data: service, isLoading, error, refetch } = useService(serviceId || "");
  const updateServiceMutation = useUpdateService(serviceId || "");

  const handleSubmit = (data: ServiceFormValues) => {
    if (!service || updateServiceMutation.isPending) return;
    updateServiceMutation.mutate(
      {
        ...data,
        description: data.description || null,
        color: data.color || null,
      },
      {
        onSuccess: (updatedService) => goToServiceDetails(updatedService.id, "finish"),
      }
    );
  };

  if (isLoading || error || !service) {
    return (
      <Page>
        <PageHeader title="Edit service" />
        <PageContent>
          {isLoading ? <RowSkeleton /> : error ? <ErrorState message={error.message} onRetry={() => void refetch()} /> : <EmptyState message="Service not found" />}
        </PageContent>
      </Page>
    );
  }

  return (
    <ServiceEdit
      key={service.id}
      service={service}
      onSubmit={handleSubmit}
      isSubmitting={updateServiceMutation.isPending}
      error={updateServiceMutation.error}
      title="Edit service"
    />
  );
}
